import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import { createCategory, fetchAllCategories } from './CategoriesApi'

const initialState={
    status:"idle",
    categories:[],
    errors:null
}

export const fetchAllCategoriesAsync=createAsyncThunk('categories/fetchAllCategoriesAsync',async()=>{
    const categories=await fetchAllCategories()
    return categories
})

export const createCategoryAsync = createAsyncThunk('categories/createCategoryAsync', async (data) => {
    const category = await createCategory(data);
    return category;
});

const categorySlice=createSlice({
    name:"categorySlice",
    initialState:initialState,
    reducers:{},
    extraReducers:(builder)=>{
        builder
            .addCase(fetchAllCategoriesAsync.pending,(state)=>{
                state.status='idle'
            })
            .addCase(fetchAllCategoriesAsync.fulfilled,(state,action)=>{
                state.status='fulfilled'
                state.categories=action.payload
            })
            .addCase(fetchAllCategoriesAsync.rejected,(state,action)=>{
                state.status='rejected'
                state.errors=action.error
            })
            .addCase(createCategoryAsync.fulfilled, (state, action) => {
                state.categories.push(action.payload)
            })

    }
})

// exporting selectors
export const selectCategoryStatus=(state)=>state.CategoriesSlice.status
export const selectCategories=(state)=>state.CategoriesSlice.categories
export const selectCategoryErrors=(state)=>state.CategoriesSlice.errors

export default categorySlice.reducer
